import * as React from 'react';
import InputReactStrap, { InputType } from 'reactstrap/lib/Input';

interface IInputProps {
  type: InputType;
  name: string;
  placeholder: string;
  handleOnChange: (name: string, value: string | number) => void;
}

const Input = (props: IInputProps) => {
  const { type, name, placeholder, handleOnChange } = props;

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleOnChange(name, e.currentTarget.value);
  };

  return <InputReactStrap type={type} name={name} placeholder={placeholder} onChange={onChange} />;
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/Input.tsx